import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between shrink-0"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "p-6 space-y-5"
};
const _hoisted_4 = {
  class: "block text-sm font-medium text-slate-700 mb-2"
};
const _hoisted_5 = {
  key: 0,
  class: "text-red-500"
};
const _hoisted_6 = {
  class: "flex items-center gap-4"
};
const _hoisted_7 = {
  key: 0,
  class: "relative group"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "mt-1 text-xs text-slate-400"
};
const _hoisted_10 = {
  class: "px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3 shrink-0"
};
const _hoisted_11 = ["disabled"];
import { ref, reactive, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { createKfAccount, updateKfAccount } from '@/api/weworkKf';
import { compressImage } from '@/utils/imageCompress';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'KfAccountFormModal',
  props: {
    show: Boolean,
    isEdit: Boolean,
    accountData: Object
  },
  emits: ['update:show', 'success', 'error'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // 表单数据
    const form = reactive({
      id: null,
      name: ''
    });

    // 头像相关
    const avatarInput = ref();
    const pendingAvatarFile = ref(null);
    const avatarPreview = ref('');
    const existingAvatar = ref('');

    // 提交 loading
    const submitting = ref(false);

    // 监听显示/隐藏
    watch(() => props.show, val => {
      if (val) {
        if (props.isEdit && props.accountData) {
          form.id = props.accountData.id;
          form.name = props.accountData.name || '';
          existingAvatar.value = props.accountData.avatar || '';
          pendingAvatarFile.value = null;
          avatarPreview.value = '';
        } else {
          resetForm();
        }
      }
    });
    const resetForm = () => {
      form.id = null;
      form.name = '';
      existingAvatar.value = '';
      pendingAvatarFile.value = null;
      avatarPreview.value = '';
    };

    // 头像选择
    const triggerAvatarUpload = () => avatarInput.value?.click();
    const handleAvatarChange = async event => {
      const file = event.target.files[0];
      if (!file) return;
      if (!file.type.startsWith('image/')) {
        ElMessage.warning('请选择图片文件');
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        ElMessage.warning('图片大小不能超过5MB');
        return;
      }
      const compressed = await compressImage(file);
      pendingAvatarFile.value = compressed;
      avatarPreview.value = URL.createObjectURL(compressed);
      existingAvatar.value = '';
      event.target.value = '';
    };
    const removeAvatar = () => {
      existingAvatar.value = '';
      pendingAvatarFile.value = null;
      avatarPreview.value = '';
    };

    // 当前显示的头像
    const displayAvatar = () => {
      return avatarPreview.value || existingAvatar.value;
    };

    // 关闭
    const handleClose = () => {
      emit('update:show', false);
    };

    // 提交
    const handleSubmit = async () => {
      if (!form.name.trim()) {
        return ElMessage.warning('请输入客服名称');
      }
      if (!props.isEdit && !pendingAvatarFile.value) {
        return ElMessage.warning('请上传客服头像');
      }
      submitting.value = true;
      try {
        if (props.isEdit) {
          await updateKfAccount(form.id, {
            name: form.name.trim(),
            avatarFile: pendingAvatarFile.value || undefined
          });
          ElMessage.success('更新成功');
        } else {
          await createKfAccount(form.name.trim(), pendingAvatarFile.value);
          ElMessage.success('创建成功');
        }
        emit('success');
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
        emit('error');
      } finally {
        submitting.value = false;
      }
    };
    const done = () => {
      submitting.value = false;
      handleClose();
    };
    __expose({
      done
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: __props.show,
          size: "md",
          scrollable: false,
          onClose: handleClose
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(__props.isEdit ? '编辑客服账号' : '新增客服账号'), 1), _createElementVNode("button", {
            onClick: handleClose,
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
          }, [...(_cache[1] || (_cache[1] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_createElementVNode("label", _hoisted_4, [_cache[2] || (_cache[2] = _createTextVNode(" 客服头像 ", -1)), !__props.isEdit ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [displayAvatar() ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("img", {
            src: displayAvatar(),
            alt: "客服头像",
            class: "w-16 h-16 rounded-full object-cover border-2 border-slate-200"
          }, null, 8, _hoisted_8), _createElementVNode("div", {
            class: "absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity rounded-full flex items-center justify-center gap-1"
          }, [_createElementVNode("button", {
            onClick: triggerAvatarUpload,
            class: "flex h-7 w-7 items-center justify-center rounded-full bg-white/20 text-white hover:bg-white/40 transition-colors cursor-pointer",
            title: "更换"
          }, [...(_cache[3] || (_cache[3] = [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          })], -1)]))]), _createElementVNode("button", {
            onClick: removeAvatar,
            class: "flex h-7 w-7 items-center justify-center rounded-full bg-white/20 text-white hover:bg-red-500/80 transition-colors cursor-pointer",
            title: "移除"
          }, [...(_cache[4] || (_cache[4] = [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))])])])) : (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: triggerAvatarUpload,
            class: "w-16 h-16 border-2 border-dashed border-slate-300 rounded-full flex flex-col items-center justify-center hover:border-primary-400 hover:bg-primary-50/30 transition-colors cursor-pointer"
          }, [...(_cache[5] || (_cache[5] = [_createElementVNode("svg", {
            class: "w-6 h-6 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5",
            d: "M12 4v16m8-8H4"
          })], -1)]))])), _cache[6] || (_cache[6] = _createElementVNode("div", {
            class: "text-xs text-slate-400"
          }, [_createElementVNode("p", null, "支持 JPG/PNG 格式"), _createElementVNode("p", null, "不超过 5MB")], -1))]), _createElementVNode("input", {
            ref_key: "avatarInput",
            ref: avatarInput,
            type: "file",
            accept: "image/*",
            class: "hidden",
            onChange: handleAvatarChange
          }, null, 544)]), _createElementVNode("div", null, [_cache[7] || (_cache[7] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode(" 客服名称 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
            type: "text",
            maxlength: "30",
            placeholder: "请输入客服名称",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, form.name]]), _createElementVNode("p", _hoisted_9, _toDisplayString(form.name.length) + "/30", 1)])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("button", {
            onClick: handleClose,
            class: "px-4 py-2 border border-slate-300 text-slate-700 rounded-lg text-sm hover:bg-slate-50 transition-colors cursor-pointer"
          }, " 取消 "), _createElementVNode("button", {
            onClick: handleSubmit,
            disabled: submitting.value,
            class: "btn-primary"
          }, _toDisplayString(submitting.value ? '提交中...' : '确定'), 9, _hoisted_11)])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })]);
    };
  }
};